const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const CREATOR_ADS = [
  { id: "lounge", label: "Velluto Lounge poster", file: "velluto-creator-lounge.jpg", w: 848, h: 1264, btn: { left: 26, top: 84.5, width: 48, height: 7 } },
  { id: "join", label: "Join Velluto poster", file: "velluto-creator-join.jpg", w: 848, h: 1264, btn: { left: 28, top: 83.5, width: 44, height: 6.5 } },
];

const MEMBER_BTN = { left: 29.7, top: 90.3, width: 40.4, height: 5.2 };
export const MEMBER_ADS = [
  { id: "masquerade", label: "Masquerade couple", file: "velluto-member-masquerade.jpg", w: 848, h: 1264, btn: MEMBER_BTN },
  { id: "livecam", label: "Live cam models", file: "velluto-member-livecam.jpg", w: 848, h: 1264, btn: MEMBER_BTN },
  { id: "society", label: "Private society", file: "velluto-member-society.jpg", w: 848, h: 1264, btn: MEMBER_BTN },
];

const ALT = {
  creator: "Apply as a Velluto creator. First 300 approved creators earn 100% for 3 months. 18+ only.",
  member: "Velluto, an exclusive private society. First 300 members: activate Basic and get Premium free for 1 month. 18+ only.",
};

const SIZED_BTN = {
  "creator-lounge": { square: [35.1, 81.9, 29.8, 6.5], story: [27.8, 76.8, 44.4, 5.4] },
  "creator-join": { square: [36.4, 81.0, 27.3, 6.0], story: [29.6, 76.0, 40.7, 5.0] },
  member: { square: [37.4, 87.2, 25.1, 4.8], story: [31.2, 81.3, 37.4, 4.0] },
};

export const AD_FORMATS = [
  { id: "poster", label: "Poster" },
  { id: "square", label: "Square 1080×1080", w: 1080, h: 1080 },
  { id: "story", label: "Story 1080×1920", w: 1080, h: 1920 },
];

export function adVariant(ad, format = "poster") {
  if (format === "poster") return ad;
  const f = AD_FORMATS.find((x) => x.id === format);
  const key = ad.file.replace("velluto-", "").replace(".jpg", "");
  const [left, top, width, height] = (SIZED_BTN[key] || SIZED_BTN.member)[format];
  return { ...ad, id: `${ad.id}-${format}`, label: `${ad.label} · ${f.label}`, file: `velluto-${key}-${format}.jpg`, w: f.w, h: f.h, btn: { left, top, width, height } };
}

export const adImageUrl = (ad) => `${window.location.origin}/ads/${ad.file}?v=2`;

export function adUrl(path, source, campaign, fallback) {
  const p = new URLSearchParams({ utm_source: source || fallback, utm_medium: "ads", utm_campaign: campaign || fallback });
  return `${window.location.origin}${path}?${p.toString()}`;
}

export const creatorAdUrl = (source, campaign) => adUrl("/join", source, campaign, "creator-launch");

export function buildAd(ad, url, kind = "creator", width = ad.w === ad.h ? 540 : 424) {
  const b = ad.btn;
  return `<!-- Velluto ${kind} ad: ${ad.label} -->
<a href="${esc(url)}" target="_blank" rel="noopener" style="position:relative;display:block;width:${width}px;max-width:100%;line-height:0;border-radius:12px;overflow:hidden">
<img src="${esc(adImageUrl(ad))}" alt="${ALT[kind]}" width="${ad.w}" height="${ad.h}" style="width:100%;height:auto;display:block">
<span style="position:absolute;left:${b.left}%;top:${b.top}%;width:${b.width}%;height:${b.height}%;border-radius:999px;cursor:pointer" aria-label="${kind === "member" ? "Join the society" : "Apply as a Creator"}"></span>
</a>`;
}

export const buildCreatorAd = (ad, url) => buildAd(ad, url, "creator");

export function downloadHtml(name, code) {
  const doc = `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>${name}</title></head><body style="margin:0;background:#0A0A0A;display:flex;align-items:center;justify-content:center;min-height:100vh">${code}</body></html>`;
  save(URL.createObjectURL(new Blob([doc], { type: "text/html" })), `${name}.html`, true);
}

export const downloadImage = (ad) => save(adImageUrl(ad), ad.file);

function save(href, name, revoke) {
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  if (revoke) setTimeout(() => URL.revokeObjectURL(href), 1000);
}
